module.exports = __webpack_public_path__ + "img/register-success.ec35a80.png";